import React, { useState, useEffect, useContext, useRef } from "react";
import "./RecentViewedProducts.css";
import { Card, Col, CardFooter, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Product_Card from "../../Common-Component/Product_Card/Product_Card";

import { Context } from "../../../utils/context";
import {
  Products,
  ProductsRecentView,
} from "../../../utils/apis/Product/Product";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
library.add(fas);

const RecentViewedProducts = () => {
  const sectionRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 575);
  const navigate = useNavigate();
  const { IMG_URL, setShimmerLoader } = useContext(Context);

  const [showAll, setShowAll] = useState(false);
  const [numToShow, setNumToShow] = useState(5);

  const toggleShowAll = () => {
    if (isMobile) {
      if (numToShow >= products.length) {
        // Collapse for mobile
        setNumToShow(10);
        sectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else {
        // Load more for mobile
        setNumToShow((prev) => Math.min(prev + 10, products.length));
      }
    } else {
      if (showAll) {
        // Collapse for desktop
        setNumToShow(5);
        setShowAll(false);
        sectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else {
        // Show all for desktop
        setNumToShow(products.length);
        setShowAll(true);
      }
    }
  };

  const [productIds, setProductIds] = useState([]);
  const [Ids, setIds] = useState([]);
  const product_id = Cookies.get("recently_viewed_dhaga");
  const [products, setProducts] = useState([]);
  const getProduct = async (productIds) => {
    setShimmerLoader(true);
    const res = await ProductsRecentView("", "", "", "", productIds);
    if (res?.success) {
      setProducts(res?.data?.data);
      setShimmerLoader(false);
    }
  };
  useEffect(() => {
    if (productIds) {
      getProduct(productIds);
    }
  }, [productIds]);

  useEffect(() => {
    const recentlyViewed = Cookies.get("recently_viewed_dhaga");

    if (recentlyViewed) {
      try {
        const parsedRecentlyViewed = JSON.parse(recentlyViewed);

        // Ensure it's an array
        if (Array.isArray(parsedRecentlyViewed)) {
          const ids = parsedRecentlyViewed.map((item) => item.product_id);
          setProductIds(ids);
        } else {
          console.error(
            "Parsed recently viewed is not an array:",
            parsedRecentlyViewed
          );
        }
      } catch (error) {
        console.error("Error parsing recently viewed:", error);
      }
    }
  }, []);

     useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
      {products.length > 0 && (
        <section className="RecentViewedProducts">
          <Container fluid>
            <div className=" mb-4 mt-5">
              <h2 className="title">Recently Viewed Products</h2>
            </div>

            <div className="desktop_view_product_category_slider" ref={sectionRef}>
              <Row>
                {products.slice(0, numToShow).map((product, index) => {
                  const price = product?.product_multiple_mains?.[0]
                    ?.product_multiple_variants?.[0]?.mrp
                    ? product?.product_multiple_mains?.[0]
                      ?.product_multiple_variants?.[0]?.mrp
                    : product?.product_variants?.[0]?.mrp;

                  const cutprice = product?.product_multiple_mains?.[0]
                    ?.product_multiple_variants?.[0]?.cutting_price
                    ? product?.product_multiple_mains?.[0]
                      ?.product_multiple_variants?.[0]?.cutting_price
                    : product?.product_variants?.[0]?.cutting_price;
                  return (
                    <Col key={index} xxl={3} xl={3} lg={4} md={6} sm={6}>
                      <Product_Card
                        image={IMG_URL + product?.image1}
                        text={product?.name}
                        product_id={product?.id}
                        subText={product?.short_description}
                        price={price}
                        cutprice={cutprice}
                        newest={product?.newest}
                        variant_id={product?.product_variants?.[0]?.id}
                        // discount={product?.product_variants?.[0]?.discount}
                        m_variant_id={
                          product?.product_multiple_mains?.[0]
                            ?.product_multiple_variants[0]?.id
                        }
                      />
                    </Col>
                  );
                })}
              </Row>
            </div>

            <div className="mobile_view_product_category_slider" ref={sectionRef}>
              <Row className="ms-0 me-0">

                {products?.map((product, index) => (
                  <Col
                    key={index}
                    xxl={3}
                    xl={3}
                    lg={3}
                    md={4}
                    sm={4}
                    xs={6}
                    className="custom_class_product"
                  >
                    <Product_Card
                      image={IMG_URL + product?.image1}
                      product_id={product?.id}
                      text={product?.name}
                      subText={product?.short_description}
                      price={product?.product_variants[0]?.mrp}
                      newest={product?.newest}
                    // variant_id={product?.variants[0]?.id}
                    />
                  </Col>
                ))}
              </Row>
            </div>

            {/* mobile_view_product_category_slider end */}
 {/* View All/ View Less Button */}
          {products.length > 0 &&
            ((isMobile && numToShow > 0) ||
              (!isMobile && (numToShow < products.length || showAll))) && (
              <div className="view-all mb-5" onClick={toggleShowAll}>
                <p>
                  {isMobile
                    ? numToShow >= products.length
                      ? "View Less"
                      : "View More"
                    : showAll
                    ? "View Less"
                    : "View All"}
                </p>
              </div>
            )}

            {products.length > 4 && (
              <div
                className="view-all mt-4"
                onClick={() => navigate("/select-from-category/1")}
              >
                <p>View All Products</p>
              </div>
            )}
          </Container>
        </section>
      )}
    </>
  );
};

export default RecentViewedProducts;
